import React, { useState } from "react";
import classNames from "classnames";
import "./Tabs.scss";

const Tabs = ({ tabItem,activeTab, className, changeFunction, changeValue }) => {
  const [activeItem, setActiveIndex] = useState(activeTab ?? 'all');
  return (
    <div className={classNames("tabs", className)}>
      {Object.keys(tabItem)?.map((item, i) => (
        <button
          key={i}
          type="button"
          className={classNames("tab-item", tabItem[item] === activeItem && "active")}
          onClick={() => {
            if(changeValue!=null){
              changeFunction(changeValue,tabItem[item]);
            }else{
              changeFunction(tabItem[item]);
            }
            
            setActiveIndex(tabItem[item])
          }}
        >
          {item}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
